/* `rely` shares the Choice asset, as in identityWeb's LOGO_MAP. */
export const CO_BRAND_LOGOS = {
  choice: 'fshield-choice-logo',
  rely: 'fshield-choice-logo',
  hwa: 'fshield-hwa-logo',
} as const;

/* This plan on a Choice/HWA/Rely group co-brands the logo without a ?cobrand link. */
export const CO_BRAND_PLAN_CODE = 'finsec2ind';

export type CoBrandCode = keyof typeof CO_BRAND_LOGOS;
